import React, { useState, useEffect } from 'react';
import Layout from 'Screens/Contextualization/Dashboard/components/Layout';
import ImportFileCreationModal from 'Screens/Contextualization/ManageEditCreate/components/ImportFileCreationModal';
import { getSummary, getStatsFiltered } from 'Screens/Contextualization/Dashboard/actions/Actions';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllHostsCountWs, selectCurrentWorkspace } from 'store/Faraday/selectors';

import EmptyVulns from 'Common/Components/EmptyVulns';
import emptyFeed from 'Images/empty-feed.png';
import ManualCreationModal from 'Screens/Contextualization/ManageEditCreate/components/ManualCreationModal';

import { StyledCol, Wrapper } from './Dashboard/styled';
import { getHostsCountInWs } from 'Screens/Contextualization/Faraday/actions/Actions';
import { selectIsFinishedLoad } from 'store/Dashboard/selectors';
import { closeModal, openModal } from 'store/modals/actions';
import { MODAL_CANT_CREATE } from 'store/modals/modals';
import selectModal from 'store/modals/selectors';
import WarningModal from 'Screens/Contextualization/ManageEditCreate/components/WarningModal';
import { CLOSED_FILTERS, CONFIRMED_FLAG_FILTERS } from 'store/Filters/constants';
import { isFilteringBy } from 'store/Filters/selectors';
import get from 'lodash/get';

const DashboardLayout = () => {
  const dispatch = useDispatch();
  const workspaceSelected = useSelector(selectCurrentWorkspace);
  const stats = useSelector((state) => get(state, 'dashboard.tools[3].data.stats', {}));
  const totalVulns = get(stats, 'total_vulns', 0);
  const finishedLoad = useSelector(selectIsFinishedLoad);

  const assetsCount = useSelector(selectAllHostsCountWs);
  const noAssets = assetsCount === 0;
  const showModalCantCreate = useSelector((state) => selectModal(state, MODAL_CANT_CREATE));

  const { confirmed } = CONFIRMED_FLAG_FILTERS;
  const { closed } = CLOSED_FILTERS;

  const isFilteringByConfirm = useSelector((state) => isFilteringBy(state, 'vulns', confirmed));
  const isFilteringByClosed = useSelector((state) => isFilteringBy(state, 'vulns', closed));

  useEffect(() => {
    if (!isFilteringByConfirm && !isFilteringByClosed) {
      dispatch(getSummary());
    }
  }, [dispatch, workspaceSelected, isFilteringByConfirm, isFilteringByClosed]);

  useEffect(() => {
    if (isFilteringByConfirm || isFilteringByClosed) {
      const parts = [];
      if (isFilteringByConfirm) parts.push('confirmed=true');
      if (isFilteringByClosed) parts.push('only_opened=true');
      dispatch(getStatsFiltered(parts.join('&')));
    }
  }, [dispatch, workspaceSelected, isFilteringByConfirm, isFilteringByClosed]);

  useEffect(() => {
    dispatch(getHostsCountInWs());
  }, [workspaceSelected, dispatch]);

  const [showModalUploadVulns, toggleModalUploadVulns] = useState(false);
  const [showModalCreateVuln, toggleModalCreateVuln] = useState(false);

  const handleDragEnter = (e) => {
    if (e.dataTransfer && e.dataTransfer.types && e.dataTransfer.types.includes('Files')) {
      toggleModalUploadVulns(true);
    }
  };

  const handleDragOver = (e) => { e.preventDefault(); };

  const createManualVulns = () => {
    if (noAssets) dispatch(openModal(MODAL_CANT_CREATE));
    else toggleModalCreateVuln(true);
  };

  useEffect(() => () => {
    dispatch(closeModal(MODAL_CANT_CREATE));
  }, [dispatch]);

  if ((totalVulns === 0) && finishedLoad) {
    return (
      <div onDragEnter={ handleDragEnter } onDragOver={ handleDragOver } style={ { height: '100%' } }>
        <EmptyVulns image={ emptyFeed } toggleModalUploadVulns={ () => toggleModalUploadVulns(true) } toggleModalCreateVuln={ createManualVulns } />
        <ImportFileCreationModal show={ showModalUploadVulns } handleClose={ () => toggleModalUploadVulns(false) } />
        { showModalCreateVuln && <ManualCreationModal handleClose={ () => toggleModalCreateVuln(false) } entity="vulns" /> }
        { showModalCantCreate && <WarningModal entity="Vulnerability" /> }
      </div>
    );
  }

  return (
    <Wrapper onDragEnter={ handleDragEnter } onDragOver={ handleDragOver }>
      <StyledCol>
        <Layout />
      </StyledCol>
      <ImportFileCreationModal show={ showModalUploadVulns } handleClose={ () => toggleModalUploadVulns(false) } />
    </Wrapper>
  );
};

export default DashboardLayout;
